"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconInvoiceRequestDefault = void 0;
var React = __importStar(require("react"));
var IconInvoiceRequestDefault = function (props) { return (React.createElement("svg", __assign({ width: "24px", height: "24px", viewBox: "0 0 24 24" }, props),
    React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M15.755,1.9998 C15.877,1.9998 15.995,2.0448 16.086,2.1248 L16.086,2.1248 L19.831,5.4368 C19.938,5.5318 20,5.6678 20,5.8118 L20,5.8118 L20,8.4998 C20,8.7768 19.776,8.9998 19.5,8.9998 C19.224,8.9998 19,8.7768 19,8.4998 L19,8.4998 L19,6.9998 L15.5,6.9998 C15.224,6.9998 15,6.7768 15,6.4998 L15,6.4998 L15,2.9998 L5.497,2.9998 C5.223,2.9998 5,3.2178 5,3.4858 L5,3.4858 L5,20.5148 C5,20.7818 5.223,20.9998 5.497,20.9998 L5.497,20.9998 L18.5,20.9998 C18.724,20.9998 19,20.7248 19,20.4998 C19,20.2238 19.224,19.9998 19.5,19.9998 C19.776,19.9998 20,20.2238 20,20.4998 C20,21.2718 19.271,21.9998 18.5,21.9998 L18.5,21.9998 L5.497,21.9998 C4.671,21.9998 4,21.3338 4,20.5148 L4,20.5148 L4,3.4858 C4,2.6658 4.671,1.9998 5.497,1.9998 L5.497,1.9998 Z M11.039,18 L11.039,19 L5.921,19 L5.921,18 L11.039,18 Z M14,16 L14,17 L5.921,17 L5.921,16 L14,16 Z M13,14 L13,15 L5.921,15 L5.921,14 L13,14 Z M14,12 L14,13 L5.921,13 L5.921,12 L14,12 Z M9,8 L9,9 L6,9 L6,8 L9,8 Z M12,6 L12,7 L6,7 L6,6 L12,6 Z M16,3.3848 L16,5.9998 L18.958,5.9998 L16,3.3848 Z", id: "Invoice", fill: "#464650" }),
        React.createElement("rect", { id: "Padding", x: 0, y: 0, width: 24, height: 24 }),
        React.createElement("polygon", { id: "Rectangle", fill: "#464650", points: "19 8 20 8 20 20.6315155 19 21" })))); };
exports.IconInvoiceRequestDefault = IconInvoiceRequestDefault;
exports.IconInvoiceRequestDefault.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconInvoiceRequestDefault;
